export const checkKeyValid = (key, domain, globalConfig) => {
  let result = false;
  if (globalConfig) {
    const keys = Object.keys(globalConfig);
    if (!keys || keys.length < 1 || !keys.includes(key)) {
      result = false;
    } else {
      const shopNames = globalConfig[key];
      if (shopNames && shopNames.length === 1 && shopNames[0] == "*") {
        result = true;
      } else if (getShopNameApply(domain, shopNames)) {
        result = true;
      }
    }
  } else {
    result = false;
  }
  return result;
};

/**
 * getShopNameApply
 * Kiểm tra shopName hiên tại  có phải trường hợp muốn triển khai Atom mới hay không;
 * @param currentName : tên shop hiện tại muốn so khớp
 * @param chars (Array) các kí tự đầu tiên của tên các shop muốn áp dụng
 * @returns đúng hoặc sai
 */
export function getShopNameApply(currentName, chars) {
  if (!chars) {
    chars = [];
  }
  let result = false;
  if (currentName && currentName.length > 0) {
    for (let i = 0; i < chars.length; i++) {
      const char = chars[i];
      const len = char.length;
      const sub = currentName.substr(0, len);
      if (char == sub) {
        result = true;
        break;
      }
    }
  }
  return result;
}
